import moment from 'moment'
import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import Select from 'react-select'
import { Drawer, DatePicker } from 'antd'

import { AiOutlineReload } from 'react-icons/ai'

import { normalize, stringifyDate, useListData, useToggle, usePet } from '../../modules'

import Receive from '../../components/reusable/receive'

import OrderModal from '../../components/modals/ordermodal'
import BillPatient from '../../components/drawers/billPatient'

const { RangePicker } = DatePicker

const BillsBreakDown = () => {
    const [selected, setSelected] = useState()
    const [ranges, setRanges] = useState([moment().startOf('day'), moment().endOf('day')])
    const [chosen, setChosen] = useState([])
    const [cashier, setCashier] = useState()
    const [categories, setCategories] = useState()
    const [category, setCategory] = useState('')
    const [string, setString] = useState('')
    const [cashStr, setCashStr] = useState('')
    const [type, setType] = useState()
    const [methods, setMethods] = useState([])

    const [billPt, toggleBillPatient] = useToggle()
    const [orderModal, toggleOrderModal] = useToggle()
    const [select, toggleSelect] = useToggle()
    const [cancelB, toggleCancel] = useToggle()

    const { user } = useSelector(state => state.application)

    usePet('paymentMethodNames', null, { notify: true, callback: ({ data }) => setMethods(data) })

    const togSelect = () => {
        setChosen([])
        toggleSelect()
    }

    const [
        { loading, error, fetch },
        { list: bills = [] },
        { navigate, Paginate, page = 1, limit = 10 }
    ] = useListData('billsBreakDown', ranges ? { string, cashier: cashier?.value, type: type?.value, from: ranges[0]?._d ?? null, to: ranges[1]?._d ?? null } : { type: type?.value, cashier: cashier?.value, string }, { notify: true }, 'bills')
    
    const [{ loading: sLoading, error: sError }] = usePet('routingGroups', {}, { notify: true, callback: ({ data }) => setCategories(data), logOutOnError: true })

    const [{ fetch: fetchCashiers }, { list: cashiers = [] }] = useListData('cashiersByClosedBy', ranges ? { string: cashStr, from: ranges[0]?._d ?? null, to: ranges[1]?._d ?? null } : { string: cashStr }, { notify: true }, 'cashiers', 100)

    const reload = () => {
        navigate(1)
        fetch()
    }

    const search = str => {
        setString(str)
        if (str?.trim().length > 2 || str.length === 0)
            reload()
    }

    const searchCashiers = str => {
        setCashStr(str)
        if (str?.trim().length > 2 || str.length === 0)
            fetchCashiers()
    }

    const selectRange = range => {
        if (range.length === 0)
            range = [moment().startOf('day'), moment().endOf('day')]
            
        setRanges(range)
        reload()
    }

    const viewOrder = ord => {
        setSelected(ord)
        toggleOrderModal()
    }

    const cancelBill = ord => {
        setSelected(ord)
        toggleCancel()
    }

    const changeType = val => {
        setType(val)
        reload()
    }

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            <Receive
                loading={sLoading}
                error={sError}>
                {
                    category ?
                        <BillPatient
                            bill={selected}
                            category={category}
                            patient={selected?.patient}
                            categories={categories}
                            onClose={() => {
                                setCategory()
                                fetch()
                            }}
                            toggle={toggleBillPatient}
                            visible={billPt} />
                        : null
                }
            </Receive>
            {
                orderModal &&
                <OrderModal
                    order={selected}
                    onPerform={fetch}
                    toggle={toggleOrderModal}
                    visible={orderModal} />
            }
            <div className="sm:flex sm:justify-between sm:items-center mb-8">
                <input
                    onChange={e => search(e.target.value)}
                    className="appearance-none block w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                    id="grid-inv-item"
                    type="text"
                    placeholder="Patient Name, IP/OP no. or Ref No." />
                <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">
                    <RangePicker
                        showTime
                        on
                        onChange={selectRange}
                        ranges={{
                            'Today': [moment().startOf('day'), moment().endOf('day')],
                            'Yesterday': [moment().subtract(1, 'day').startOf('day'), moment().subtract(1, 'day').endOf('day')],
                            'This Week': [moment().startOf('week'), moment().endOf('week')],
                            'This Month': [moment().startOf('month'), moment().endOf('month')],
                        }}/>
                </div>
            </div>
            <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                <header className="px-5 py-4 border-b border-gray-100 flex justify-between items-center">
                    <span>
                        <h2 className="font-semibold text-gray-800">Bills Breakdown</h2>
                    </span>
                    <span className="flex items-center justify-between">
                        <Select
                            value={cashier}
                            isClearable
                            onInputChange={ inp => searchCashiers(inp) }
                            onChange={ val => {
                                setCashier(val)
                                reload()
                            } }
                            styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                            options={cashiers.map(user => ({ label: user.name, value: user._id }))}
                            placeholder="Select Cashier" />
                        <button onClick={reload} className="btn ml-2 py-3 hisani-btn-green-light text-white">
                            <AiOutlineReload style={{ color: "white" }} />
                        </button>
                    </span>
                </header>
                <div className="p-3">
                    <Receive
                        progress
                        loading={loading}
                        error={error}>
                        {
                            bills?.length > 0 ?
                                <div className="overflow-x-auto">
                                    <table className="table-auto w-full">
                                        {/* Table header */}
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                            <tr>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">No</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Patient</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Ref No.</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Total</div>
                                                </th>
                                                {
                                                    methods?.map(method => 
                                                        <th className="p-2">
                                                            <div className="font-semibold text-center">{ method }</div>
                                                        </th>
                                                    )
                                                }
                                                {
                                                    categories?.map(category => 
                                                        <th className="p-2">
                                                            <div className="font-semibold text-center">{ category.name }</div>
                                                        </th>
                                                    )
                                                }
                                            </tr>
                                        </thead>
                                        {/* Table body */}
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {
                                                bills.map((order, key) => {
                                                    let soFar = order.payments.reduce((total, pym) => total + pym.amount, 0)

                                                    return (
                                                        <tr>
                                                            <td className="p-2">
                                                                <div className="text-center">
                                                                    {((page - 1) * limit) + (key + 1)}
                                                                </div>
                                                            </td> 
                                                            <td className="p-2">
                                                                <div className="">{order?.patient?.name}</div>
                                                                <p className="text-gray-500 mb-0 text-xs italic">{ stringifyDate(order.date) }</p>
                                                            </td>
                                                            <td className="p-2">
                                                                <button onClick={() => viewOrder(order)} className="btn ml-2 py-1 hisani-btn-green-light text-white">#{ order.orderNo < 1000 ? ('00000' + order.orderNo).slice(-4) : order.orderNo }</button>
                                                            </td>
                                                            <td className="p-2">
                                                                <div className="text-center">Ksh. {normalize(order.items.reduce((total, item) => total + (item.quantity * (item?.unitPrice - (item?.discount ?? 0))), 0) - (order.discount ?? 0))}</div>
                                                            </td>
                                                            {
                                                                methods?.map(method => {
                                                                    let total = order.payments.reduce((total, pym) => total + (pym.method === method ? pym.amount : 0), 0)

                                                                    return (
                                                                        <th className="p-2">
                                                                            <div className="font-semibold text-center">{ total }</div>
                                                                        </th>
                                                                    )
                                                                })
                                                            }
                                                            {
                                                                categories?.map(category  => {
                                                                    let hapa = false
                                                                    let total = order.items.reduce((total, itm) => {
                                                                        if (!itm?.ref?.category)
                                                                            hapa = true

                                                                        if (category.categories.includes(itm?.ref?.category))
                                                                            return total + itm.quantity * (itm?.unitPrice - (itm?.discount ?? 0))

                                                                        return total + 0
                                                                    }, 0)

                                                                    if ((soFar - total) < 0) {
                                                                        if (soFar < 0) {
                                                                            total = 0
                                                                        } else {
                                                                            total = soFar
                                                                        }
                                                                    }

                                                                    soFar -= total

                                                                    return (
                                                                        <th className="p-2">
                                                                            <div className="font-semibold text-center">{ total }</div>
                                                                        </th>
                                                                    )
                                                                })
                                                            }
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                :
                                <div className="w-full h-16 flex items-center justify-center">
                                    <p className="font-semibold text-base">{string.trim().length > 2 ? `No bills matching "${string}" found` : type?.value === 'All' ? "Please click above to create a new bill" : 'No bills found'}</p>
                                </div>
                        }
                    </Receive>
                    {Paginate}
                </div>
            </div>
        </div>
    )
}

export default BillsBreakDown